export enum EnvironmentEnum {
  TEST = 'test',
  PROD = 'prod'
}
